import React from 'react';
import { Input, CustomInput } from 'reactstrap';

export const Filter = ({ column }) => {
  return (
    <div style={{ marginTop: 5 }}>
      {column.canFilter && column.render('Filter')}
    </div>
  );
};

export const DefaultColumnFilter = ({
  column: {
    filterValue,
    setFilter,
    preFilteredRows: { length },
  },
}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      placeholder={`recherche (${length}) ...`}
      title={filterValue || `recherche (${length}) ...`}
    />
  );
};

export const SelectColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
  capitalizeFirst = false,
  customKey = null
}) => {
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      if(customKey)
        eval(`options.add(${customKey.replace(/\$/g, "row.original")});`)
      else if(row.values[id] !== "" && row.values[id] !== null && row.values[id] !== undefined)
        options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <CustomInput
      id='custom-select'
      type='select'
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      style={{minWidth: "100px"}}
    >
      <option value=''>Tout</option>
      {options.map((option, key) => (
        <option key={key} value={option}>
          {capitalizeFirst ? option.toString().charAt(0).toUpperCase() + option.toString().slice(1).toLowerCase() : option}
        </option>
      ))}
    </CustomInput>
  );
};

export const NumberRangeColumnFilter = ({
  column: { filterValue = [], preFilteredRows, setFilter, id },
  isPrice = false
}) => {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? (preFilteredRows[0].values[id] || 0) : 0
    let max = preFilteredRows.length ? (preFilteredRows[0].values[id] || 0) : 0
    preFilteredRows.forEach(row => {
      min = Math.min(row.values[id] || 0, min)
      max = Math.max(row.values[id] || 0, max)
    })
    return [min, max]
  }, [id, preFilteredRows])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Input
        value={filterValue[0] || filterValue[0] === 0 ? filterValue[0] : ''}
        type="text"
        onChange={e => {
          const val = e.target.value;
          if(/^[0-9\b]+$/.test(val) || val === "")
            setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
        }}
        placeholder={`(${isPrice && min !== null && min !== undefined && min !== "" && !isNaN(min) ? min.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh" : min})`}
        title={`Minimum: ${isPrice && min !== null && min !== undefined && min !== "" && !isNaN(min) ? min.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh" : min}`}
        style={{
          width: '70px',
          marginRight: '0.5rem',
          flex: 1
        }}
      />
      à
      <Input
        value={filterValue[1] || filterValue[1] === 0 ? filterValue[1] : ''}
        // value={filterValue[1] || ''}
        type="text"
        onChange={e => {
          const val = e.target.value
          if(/^[0-9\b]+$/.test(val) || val === "")
            setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
        }}
        placeholder={`(${isPrice && max !== null && max !== undefined && max !== "" && !isNaN(max) ? max.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh" : max})`}
        title={`Maximum: ${isPrice && max !== null && max !== undefined && max !== "" && !isNaN(max) ? max.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh" : max}`}
        style={{
          width: '70px',
          marginLeft: '0.5rem',
          flex: 1
        }}
      />
    </div>
  )
}

export const DateRangeColumnFilter = ({
  column: {
    filterValue = [],
    preFilteredRows,
    setFilter,
    id
  }}) => {
  // const [min, max] = React.useMemo(() => {
  //   let min = preFilteredRows.length ? new Date(preFilteredRows[0].values[id]) : new Date(0)
  //   let max = preFilteredRows.length ? new Date(preFilteredRows[0].values[id]) : new Date(0)

  //   preFilteredRows.forEach(row => {
  //     const rowDate = new Date(row.values[id])

  //     min = rowDate <= min ? rowDate : min
  //     max = rowDate >= max ? rowDate : max
  //   })

  //   return [min, max]
  // }, [id, preFilteredRows])

  return (
    <div className="dateTableFilterDiv">
      <Input
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [val ? val : undefined, old[1]])
        }}
        type="date"
        value={filterValue[0] || ''}
        className="dateTableFilterInput"
      />
      {' à '}
      <Input
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [old[0], val ? val.concat('T23:59:59.999Z') : undefined])
        }}
        type="date"
        value={filterValue[1]?.slice(0, 10) || ''}
        className="dateTableFilterInput"
      />
    </div>
  )
}
